import script from "./PracticeModeSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./PracticeModeSelect.vue?vue&type=script&setup=true&lang=js"

import "./PracticeModeSelect.vue?vue&type=style&index=0&id=3aae07d1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aae07d1"]])

export default __exports__